import { color, size } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { StatusBox as StatusBoxComponent } from "../../StatusBox";
export const StatusBox = styled(StatusBoxComponent) `
  border-top-width: ${size.border.base.hairline};
  border-right-width: ${size.border.base.hairline};
  border-bottom-width: ${size.border.base.hairline};
  border-style: solid;
  &.info {
    border-color: ${color.status.info.default};
  }
  &.warning {
    border-color: ${color.status.warning.default};
  }
  &.error {
    border-color: ${color.status.error.default};
  }
  &.success {
    border-color: ${color.status.success.default};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RhdHVzQm94LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQmFubmVyL3N0eWxlZC9TdGF0dXNCb3gudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxJQUFJLEVBQUUsTUFBTSxnREFBZ0QsQ0FBQztBQUM3RSxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUN2QyxPQUFPLEVBQUUsU0FBUyxJQUFJLGtCQUFrQixFQUFFLE1BQU0saUJBQWlCLENBQUM7QUFFbEUsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUFHLE1BQU0sQ0FBQyxrQkFBa0IsQ0FBQyxDQUFBO3NCQUM3QixJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxRQUFRO3dCQUN2QixJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxRQUFRO3lCQUN4QixJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxRQUFROzs7b0JBRzlCLEtBQUssQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU87OztvQkFHekIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsT0FBTzs7O29CQUc1QixLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxPQUFPOzs7b0JBRzFCLEtBQUssQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLE9BQU87O0NBRS9DLENBQUMifQ==